import './../controllers/sortable-table-controller.js';
import { analyticsEvent } from './../controllers/analytics-controller.js';
$(function () {	
	var bookmarksPagesize = $('.bookmarks-count').val(),
		IsUserAuthenticated = $("#IsUserAuthenticated").val(),
		currentPage = 1;
						
	var fetchBookmarksData = function (pageNo, pageSize) {
		// Hide backend containers
		$("#bookmarksFromBackend, #bookmarksPaginationBackend").hide();
	
		// Show loader row
		const loaderRow = `
			<tr>
				<td colspan="5" style="text-align: center;">
					<img src="/dist/img/loader.svg" alt="Loading..." class="loading" />
				</td>
			</tr>
		`;
		$("#bookmarksFromFrontend").html(loaderRow);
	
		const requestData = { PageNo: pageNo, PageSize: pageSize };
		const isOmdiaTheme = $('body').hasClass('theme-omdia');
	
		// var apiUrl;
		// const host = window.location.host;
		// if (host.includes("127.0.0.1") || host.includes("localhost")) {
		// 	apiUrl = "/api-json/bookmarks.json";
		// } else {
		// 	apiUrl = "/api/bookmark/getbookmarkitems";
		// }

		// Fetch bookmarks data from API
		// $.get("/api-json/bookmarks.json", requestData, function (response) {
		$.post("/api/bookmark/getbookmarkitems", requestData, function (response) {
			if (response && response.respone && Array.isArray(response.respone.bookmarkList) && response.respone.bookmarkList.length > 0) {			
				const bookmarksData = response.respone.bookmarkList.map(item => {
					const {
						url = "#",
						title = "Untitled",
						savedOn = "",
						savedOnFormattedDate = "",
						publishedOn = "",
						publishedOnFormattedDate = "",
						contentType = "",
						publication = {},
						documentId,
						salesforceId,
						publicationDescription = ""
					} = item;
	
					return `
						<tr>
							<td class="sortable-table__col sortable-table__submit-wrapper">
								<div class="form-remove-saved-document"
									data-api-url="/Account/api/SavedDocumentApi/RemoveItem/"
									data-document-id="${documentId}"
									data-salesforce-id="${salesforceId}"
									data-title="${title.replace(/"/g, '&quot;')}"
									data-publication="${(publication.name || '').replace(/"/g, '&quot;')}">
									<button type="button" class="button--outline js-lightbox-modal-trigger"
										data-lightbox-modal="js-remove-article-modal"
										data-lightbox-modal-title="Remove Article"
										data-info='{
											"event_name": "bookmark removal", 
											"bookmark_title": "${title}", 
											"bookmark_publication": "${publication.name || ''}" 
										}'
										data-lightbox-modal-body="${publicationDescription.replace(/"/g, '&quot;')}"
										data-lightbox-modal-success-target="form-remove-saved-document">
										Remove
									</button>
								</div>
							</td>
							${isOmdiaTheme ? `<td class="sortable-table__col sortable-table__col--has-title sortable-table__col--title">
								<a 
									href="${url}" 
									class="click-utag" 
									data-info='{ 
										"event_name": "unbookmark", 
										"bookmark_title": "${title}", 
										"bookmark_publication": "${publication.name || ''}" 
									}'
									${contentType && contentType.toLowerCase() == 'press release' || contentType && contentType.toLowerCase() == 'blog' ? 'target="_blank" rel="noopener"' : ''}
								>
									${title} ${contentType && contentType.toLowerCase() == 'press release' || contentType && contentType.toLowerCase() == 'blog' ? '<i class="fas fa-external-link-alt"></i>' : ''}
								</a>
							</td>
							<td class="sortable-table__col sortable-table__col--has-title sortable-table__col--date l-no-wrap" data-savedondate="${savedOnFormattedDate}">${savedOnFormattedDate}</td>
							${isOmdiaTheme ? `<td class="sortable-table__col">${contentType}</td>` : ''}
							<td class="sortable-table__col">${contentType && contentType.toLowerCase() === "product" ? "-" : publishedOnFormattedDate}</td>` : `
							
							<td class="sortable-table__col">${publication.name}</td>
							
							<td class="sortable-table__col sortable-table__col--has-title sortable-table__col--title">
								<a href="${url}" class="click-utag" data-info='{
										"event_name": "unbookmark",
										"bookmark_title": "${title}",
										"bookmark_publication": "${publication.name || ''}"
									}'>${title}</a>
							</td>
							<td class="sortable-table__col sortable-table__col--has-title sortable-table__col--date l-no-wrap" data-savedondate="${savedOnFormattedDate}">${savedOnFormattedDate}</td>
							`}
							
							
							
						</tr>
					`;
				}).join('');
	
				$("#bookmarksFromFrontend").html(bookmarksData);
				$("#bookmarksPaginationFrontend").pagination({
					dataTotalLength: response.respone.totalCount,
					currentPageItem: pageNo,
					dataPerPage: pageSize
				});
				// Bind event to open modal and make API call
				bindModalEventToTrigger();
			} else {
				$("#bookmarksFromFrontend").closest('table').hide();
				$("#bookmarkNotFound").html(`No bookmarks found.`);
			}
		});
	};
		
	// Separate method to bind modal event and make API call
	function bindModalEventToTrigger() {
		$(".js-lightbox-modal-trigger").off('click').on('click', function () {
			const $btn = $(this);
			const $modal = $(`.${$btn.data('lightbox-modal')}`);
			const $wrapper = $btn.closest('.form-remove-saved-document');

			const documentId = $wrapper.data('document-id');
			const salesforceId = $wrapper.data('salesforce-id');
			const apiUrl = $wrapper.data('api-url');
			const modalBody = $btn.data('lightbox-modal-body');
			
			// Freeze the background and show modal
			$('body').addClass('lightboxed').append('<div class="lightbox-modal__backdrop"></div>');
			$modal.find('.modal-body').html(modalBody);
			$modal.show();

			// Setup the confirmation for removal
			$modal.find('.js-lightbox-modal-submit').off('click').on('click', function () {
				window.INFORMA.Spinner.Show($('body'));
				// Send the API call to remove the bookmark
				$.post(apiUrl, {
					DocumentID: documentId,
					SalesforceID: salesforceId,
				}, function (response) {
					console.log('Bookmark removed successfully:', response);
					if (window.analytics_data) {
						analyticsEvent($.extend(window.analytics_data, $btn.data('info')));
					}
					$modal.hide();
					$('body').removeClass('lightboxed');
					$('.lightbox-modal__backdrop').remove();
				
					// Optionally remove the row
					$wrapper.closest('tr').remove();
					window.INFORMA.Spinner.Hide();
				});
			});
			
			// Prevent form submission on click
			return false;
		});
	}

	if(bookmarksPagesize) {
    	fetchBookmarksData("1", bookmarksPagesize);
	}
	
	$("#bookmarksPaginationFrontend").on('click', "li", function(e){
		e.preventDefault();
		var pageIndex = $(this).find("a").attr("data-index");
		currentPage = pageIndex;
		fetchBookmarksData(pageIndex, bookmarksPagesize);
		// $('link[rel="canonical"]').attr('href', window.location);
	});
	
    $.fn.pagination = function (options) {		
		var _this = this,
			defaults = {
				dataPerPage: 10,
				populatePageCount: 5,
				startPageFrom: 1,
			},
			settings = $.extend({}, defaults, options),
			firstPageIndex = 1,
			initPageIndex = settings.startPageFrom,
			lastPageIndex = settings.populatePageCount,
			pageIncrement,
			activePageIndex = 1,
			totalPageCount = "",
			currentPageItem = settings.currentPageItem;
			
			
		if(this.length > 1){
			this.each(function(){ $(this).pagination(options) });
			return this;
		}
	
		this.populateData = function(){
			totalPageCount = Math.ceil(settings.dataTotalLength / settings.dataPerPage);
			var paginationItem = "";
				
			if(initPageIndex != firstPageIndex){
				paginationItem += `<li>
									<a href="#?page=${firstPageIndex}" data-index="${firstPageIndex}" title="Page ${firstPageIndex}">First</a>
								   </li>
								   <li>...</li>`;
			}
			
			for (var i = initPageIndex; i <= totalPageCount; i++) {
				if(i <= lastPageIndex){
					if(activePageIndex && activePageIndex == i){
						paginationItem += `<li class="active">
											<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
										  </li>`;
					}else{					
						paginationItem += `<li>
											<a href="#?page=${i}" data-index="${i}" title="Page ${i}">${i}</a>
										  </li>`;
					}
				}
			}
			
			if(totalPageCount > lastPageIndex){
				paginationItem += `<li>...</li>`
				
				if(totalPageCount == activePageIndex){
					paginationItem += `<li class"active">
										<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
									  </li>`;
				}else {
					paginationItem += `<li>
										<a href="#?page=${totalPageCount}" data-index="${totalPageCount}" title="Page ${totalPageCount}">Last</a>
									  </li>`;
				}
			}
			
			if (totalPageCount <= firstPageIndex) {
				paginationItem = "";
			}			
			this.html(paginationItem);	
		}
		
		this.initialize = function(){
			_this.populateData();
				
			if(currentPageItem){
				activePageIndex = currentPageItem;
			}

			if (currentPageItem && currentPageItem > 2 && currentPageItem <= totalPageCount - 2) {
				initPageIndex = Number(currentPageItem) - 2;
				lastPageIndex = Number(currentPageItem) + 2;
			}
			if (currentPageItem && currentPageItem <= 2) {
				initPageIndex = settings.startPageFrom,
				lastPageIndex = settings.populatePageCount
			}
			if(totalPageCount > 5){
				if (currentPageItem && currentPageItem >= totalPageCount - 2) {
					initPageIndex = totalPageCount - 4;
					lastPageIndex = totalPageCount;
				}
			}
			_this.populateData();
		};
		this.initialize();		
			
		$(_this).on('click', "li", function(e){
			e.preventDefault();
			//e.stopPropagation();
			currentPageItem = $(this).find("a").attr("data-index");
			_this.initialize();
		});
	};
});